import React, { useContext, useEffect, useRef, useState } from 'react'
import LinkWithStatus from '../common/LinkWithStatus'
import Pagination from '../common/Pagination'
import LoadingSpinnerOverlay from '../common/LoadingSpinnerOverlay'
import ConnectorViewRow from './ConnectorViewRow'
import { useParams, useSearchParams } from 'react-router-dom'
import { deleteRequest, getRequest, postRequest } from '../../services/base'
import { NavContext } from '../../context/global_context'
import NoRecordsFound from '../common/NoRecordsFound'
import { downloadErrorLogs } from '../../utils/common'

const ConnectorViewsTable = ({}) => {
  let { vehicle } = useParams()
  const [value, dispatch] = useContext(NavContext)

  const [searchParams, setSearchParams] = useSearchParams()

  const [searchQuery, setSearchQuery] = useState(searchParams.get('q'))
  const [openedMappings, setOpenedMappings] = useState([])
  const [loading, setLoading] = useState(false)
  const [connectorViews, setConnectorViews] = useState([])
  const [pagination, setPagination] = useState({
    count: 0,
    next: null,
    previous: null,
    current_page: 1,
  })
  const currentUrl = useRef(
    `/api/connector_views/?vehicle=${vehicle}&search=${
      searchParams.get('q') ? searchParams.get('q') : ''
    }`
  )

  useEffect(() => {
    getConnectorViewsData()
  }, [])

  const deleteInstance = async (id, name) => {
    if (window.confirm(`Are you really wan't to remove ${name}`) == true) {
      let res = await deleteRequest(
        `/api/connector_views/delete_views/${id}/instance/`
      )
      dispatch({
        type: 'notification',
        data: {
          notification_type: 'success',
          msg: `Connector View Successfully Deleted !`,
        },
      })
      getConnectorViewsData()
    }
  }

  const validateUpload = async (id) => {
    if (window.confirm(`Are you really wan't to validate Upload`) == true) {
      dispatch({
        type: 'loader',
        data: {
          caption: `Validating Missing SVG ...`,
          showLoader: true,
        },
        notification: {},
      })
      let res = await postRequest(`/api/connector_views/validate-upload/${id}/`)
      if (res?.data?.length > 0) {
        downloadErrorLogs(res?.data, 'svg-missing-references.txt')
      }
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: `Validation Successfully Done.`,
          },
        })
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  const getConnectorViewsData = async () => {
    setLoading(true)

    let response = await getRequest(currentUrl.current)
    if (response?.results?.length > 0) {
      setConnectorViews(response.results)
      setPagination(response.pagination)
    }
    setLoading(false)
  }

  const toggleMappingActions = (mapping) => {
    let tempopenedMappings = [...openedMappings]
    if (tempopenedMappings.includes(mapping.id)) {
      tempopenedMappings = tempopenedMappings.filter((m) => m !== mapping.id)
    } else {
      tempopenedMappings.push(mapping.id)
    }
    setOpenedMappings(tempopenedMappings)
  }

  const mappingIsOpened = (mapping) => {
    return openedMappings.includes(mapping.id)
  }

  const startAutoMapping = async (id) => {
    if (
      window.confirm(
        `Are you sure you want start auto mapping, This will delete existing mapping and create new`
      ) === true
    ) {
      dispatch({
        type: 'loader',
        data: {
          caption: `Auto Mapping in progress ...`,
          showLoader: true,
        },
        notification: {},
      })

      const formData = new FormData()
      let res = await postRequest(
        `/api/connector_views/auto-mapping/${id}/`,
        formData
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res?.msg,
          },
        })
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  const uploadMappingJson = async (id, e) => {
    if (
      window.confirm(
        `Are you sure you want upload mapping json, This will delete existing mapping and create new`
      ) === true
    ) {
      e.preventDefault()

      dispatch({
        type: 'loader',
        data: {
          caption: `Mapping Json upload in progress ...`,
          showLoader: true,
        },
        notification: {},
      })

      const formData = new FormData()
      const { name, files } = e.target
      formData.append('mapping_json', files[0], `${name}.json`)
      let res = await postRequest(
        `/api/connector_views/upload-mapping-json/${id}/`,
        formData
      )
      if (res?.status) {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'success',
            msg: res?.msg,
          },
        })
      } else {
        dispatch({
          type: 'notification',
          data: {
            notification_type: 'error',
            msg: res?.msg,
          },
        })
      }
    }
  }

  return (
    <div className="flex flex-col pt-6 flex-grow">
      <LoadingSpinnerOverlay active={loading} />
      <div className="flex flex-row w-full flex-grow">
        <div className="w-2/3">
          <form
            className="flex flex-col w-full space-y-2 pb-5"
            acceptCharset="UTF-8"
            method="get"
          >
            <div className="flex space-x-5">
              <div className="w-1/3">
                <input
                  autoComplete="off"
                  className="w-full bg-white h-10 px-5 pr-5 rounded focus:outline-none text-black"
                  placeholder="Enter keyword"
                  type="search"
                  name="q"
                  value={searchQuery || ''}
                  onChange={(e) => setSearchQuery(e.target.value)}
                />
              </div>
              <div className="w-2/3">
                <button className="btn">Search</button>
              </div>
            </div>
          </form>
        </div>
        <div className="w-1/3 text-right">
          <LinkWithStatus
            href={`/vehicles/${vehicle}/connector_views/new`}
            className={
              'cursor-pointer inline-block bg-tracer-lt-blue font-light hover:bg-blue-700 text-white py-2 px-3 rounded'
            }
            title={'New Vehicle View'}
          />
        </div>
      </div>
      <div className="flex flex-row bg-tracer-lt-blue rounded-t text-white px-3 text-sm font-light">
        <div className="w-full px-2">Vehicle Views</div>
      </div>
      {connectorViews?.length < 1 && (
        <NoRecordsFound
          loading={loading}
          caption={'Vehicle Views data loading...'}
        />
      )}

      {connectorViews.map((connectorView) => (
        <ConnectorViewRow
          key={`connector-view-row-${connectorView.id}`}
          vehicle={vehicle}
          connectorView={connectorView}
          isOpen={mappingIsOpened(connectorView)}
          toggleMappingActions={toggleMappingActions}
          showLoader={(e) => setLoading(true)}
          deleteInstance={(id) => deleteInstance(id, connectorView?.name)}
          validateUpload={(id) => validateUpload(id)}
          startAutoMapping={(id) => {
            startAutoMapping(id)
          }}
          uploadMappingJson={(id, e) => {
            uploadMappingJson(id, e)
          }}
        />
      ))}
      {pagination && (
        <div className="flex flex-col w-full space-y-2 py-6 text-center">
          <Pagination
            context={pagination}
            onClickNext={(url) => {
              currentUrl.current = url
              getConnectorViewsData()
            }}
            onClickPrev={(url) => {
              currentUrl.current = url
              getConnectorViewsData()
            }}
          />
        </div>
      )}
    </div>
  )
}

ConnectorViewsTable.propTypes = {}

export default ConnectorViewsTable
